// TanStack QueryClient настроен под наши реалии:
// - refetchOnWindowFocus: false - панель поллит через setInterval и SSE, лишнее давление на api не нужно.
// - retry: 0 для 4xx (не мутирует ситуацию), 1 для 5xx.
// - 401 на любом query - глобальный редирект на /login (обрабатывается в App.tsx через onError-подписку).

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 1;
        },
        staleTime: 3_000,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
